import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Radial = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Radial' {...props}>
    <circle cx='12' cy='12' r='11' fill='none' stroke='#000' strokeWidth='2' />
  </StyledIcon>
);
